<div [ngStyle]="{ 'display' : this.fomCheckService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="table-fields">
        <div>
          <table>
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">ICAO Code</th>
                <th scope="col">DOC</th>
                <th scope="col">FOM</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let el of this.fomCheckService.model?.navaids; let i = index">
                <td>{{ el.navaidid }}</td>
                <td>{{ el.name }}</td>
                <td>{{ el.navaidtype }}</td>
                <td>{{ el.icaocc }}</td>
                <td>{{ el.doc }}</td>
                <td>{{ el.arinc424fom }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>




